import { useQuery } from '@tanstack/react-query';

import { libraryApi } from '../api/library.api.js';

export function useAuthorSuggestions(query: string, enabled = true) {
  const trimmed = query.trim();
  return useQuery({
    queryKey: ['authors', 'suggest', trimmed],
    queryFn: () => libraryApi.suggestAuthors(trimmed, 8),
    enabled: enabled && trimmed.length >= 1,
    staleTime: 5 * 60 * 1000,
  });
}
